import React, { post, useState, MyIcon, useEffect, useNavigate, useLocation, get, Func, config } from '@/common';
import { Outlet } from 'react-router-dom';
import { Layout, Menu, Avatar, Popover, Modal, Badge, Tooltip, Space } from 'antd';
import {
  DownOutlined,
  MenuUnfoldOutlined,
  MenuFoldOutlined
} from '@ant-design/icons';
import './Panel.scss';
import Funcs from '@/Func'

const { Header, Sider, Content } = Layout;

function Main() {
  const navigate = useNavigate()
  const pathname = useLocation().pathname
  const [menuItems, setMenuItems] = useState<any>();
  const member = JSON.parse(localStorage.getItem('member') || '{}')
  const modules = JSON.parse(localStorage.getItem('module') || '[]')
  const [menuSelectedKeys, setMenuSelectedKeys] = useState<any>();
  const [menuOpenKeys, setMenuOpenKeys] = useState<any>();
  const [menuChild, setMenuChild] = useState<any>();
  const [organizationPopover, setOrganizationPopover] = useState<any>();
  const configs = Funcs.getConfigs()

  const initialize = () => {
    let menu_items: any = []

    modules.forEach((e: any, k: number) => {
      let item: any = {
        label: e.name,
        key: k.toString(),
        icon: <MyIcon type={`icon-${e.ico}`} />
      }
      if (e.children) {
        let children: any = []
        e.children.forEach((e_1: any, k_1: any) => {
          let item_children = {
            label: e_1.name,
            key: `${k}-${k_1}`,
          }
          children.push(item_children)
        })
        item.children = children
      }
      menu_items.push(item)
    })
    setMenuItems(menu_items)
    updateMenu()
  }

  const menuOnOpenChange = (e: any) => {
    setMenuOpenKeys(e)
  }

  const menuClick = (e: any) => {
    let key = e.key.split('-')
    if (key.length === 1) {
      navigate(modules[key[0]].url)
    } else {
      navigate(modules[key[0]].children[key[1]].url)
      // updateMenuChild(modules[key[0]].children[key[1]].children)
    }
  }

  // const updateMenuChild = (children: any) => {
  //   if (children) {
  //     let dom: any = []
  //     children.forEach((e: any) => {
  //       if (e.children) {
  //         dom.push(<div className='title'>{e.name}</div>)
  //         e.children.forEach((e_1: any) => {
  //           dom.push(<div className={`item ${e_1.url === pathname ? 'on' : ''}`} onClick={() => navigate(e_1.url)}>{e_1.name}</div>)
  //         });
  //       } else {
  //         dom.push(<div className={`item ${e.url === pathname ? 'on' : ''}`} onClick={() => navigate(e.url)}>{e.name}</div>)
  //       }
  //     });
  //     setMenuChild(<div className='menu_child'>{dom}</div>)
  //   } else {
  //     setMenuChild(null)
  //   }
  // }

  const updateMenu = () => {
    let dom_menu_child: any = null
    modules.forEach((e: any, k: number) => {
      if (e.children) {
        e.children.forEach((e_1: any, k_1: number) => {
          if (e_1.children) {
            let have = false
            let menu_child: any = []
            // 第二菜单
            e_1.children.forEach((e_2: any) => {
              if (e_2.children) {
                menu_child.push(<div className='title' key={e_2.id}>{e_2.name}</div>)
                e_2.children.forEach((e_3: any) => {
                  if (e_3.url === pathname) {
                    setMenuOpenKeys([k.toString()])
                    setMenuSelectedKeys([`${k}-${k_1}`])
                    have = true
                  }
                  menu_child.push(<div className={`item ${e_3.url === pathname ? 'on' : ''}`} onClick={() => navigate(e_3.url)} key={e_3.id}>{e_3.name}</div>)
                });
              } else {
                if (e_2.url === pathname) {
                  setMenuOpenKeys([k.toString()])
                  setMenuSelectedKeys([`${k}-${k_1}`])
                  have = true
                }
                menu_child.push(<div className={`item ${e_2.url === pathname ? 'on' : ''}`} onClick={() => navigate(e_2.url)} key={e_2.id}>{e_2.name}</div>)
              }
            });
            if (have) {
              dom_menu_child = menu_child
            }
          } else {
            if (e_1.url === pathname) {
              setMenuOpenKeys([k.toString()])
              setMenuSelectedKeys([`${k}-${k_1}`])
            }
          }
        })
      } else {
        if (e.url === pathname) {
          setMenuSelectedKeys([k.toString()])
        }
      }
    })
    setMenuChild(dom_menu_child ? <div className='menu_child'>{dom_menu_child}</div> : null)
  }

  useEffect(() => {
    initialize()
    getOrganization()
  }, [])

  useEffect(() => {
    // 路径改变菜单更新
    if (menuItems) {
      updateMenu()
    }
  }, [pathname])

  const userPopover = <div className='user-popover'>
    <Popover trigger="click" content={organizationPopover} placement="right">
      <a>
        <MyIcon type="icon-qiehuangongsi" />
        <div>切换公司</div>
      </a>
    </Popover>
    <a onClick={() => { logout() }}>
      <MyIcon type="icon-tuichu" />
      <div>退出登录</div>
    </a>
    <div className='version'>版本：{config.version}</div>
  </div>

  const logout = () => {
    Modal.confirm({
      title: "确认是否退出登录？",
      onOk() {
        post('/system/member/logout')
        localStorage.removeItem('member')
        localStorage.removeItem('module')
        let url = '/login'
        navigate(url)
      }
    })
  }
  const getOrganization = () => {
    get('/system/member/organizations').then(data => {
      setOrganizationPopover(<div className='organization-popover'>
        {
          data.data.map((e: any, k: number) => <a onClick={() => { Funcs.switchOrganization(e.id) }} key={k}>{e.name}</a>)
        }
      </div>)
    })
  }
  return (
    <div className="mos">
      <div className='menu'>
        <a className='logo' onClick={() => navigate('/')}>
          <img src={(configs.system && ((configs.system.logo_rectangle && Func.getRealUrl(configs.system.logo_rectangle)) || (configs.system.logo && Func.getRealUrl(configs.system.logo)))) || "/images/logo_rectangle.png"} alt="logo"></img>
        </a>
        <Menu mode="inline" items={menuItems} selectedKeys={menuSelectedKeys} onOpenChange={menuOnOpenChange} openKeys={menuOpenKeys} onClick={menuClick} />
        <div className='foot'>
          <Popover trigger="hover" content={userPopover} placement="right">
            <div className='user' onClick={() => { navigate('/system/my') }}>
              <div className='left'>
                <Avatar size="small" src={member.avatar_real} />
              </div>
              <div className='right'>
                <div className='top'>
                  <div className='name'>{member.name}</div>
                  <div className='role'>{member.role.name}</div>
                </div>
                <div className='bottom'>
                  <div className='organization'>
                    <MyIcon type="icon-gongsixinxi" />
                    <div>{member.organization.name}</div>
                  </div>
                </div>
              </div>
            </div>
          </Popover>
        </div>
      </div>
      {menuChild}
      <div className='content'>
        <Outlet />
      </div>
    </div>
  )
}

export default Main